import { ReactNode } from 'react';

export type Alignment = 'left' | 'center' | 'right';
export type TableVariant = 'small' | 'medium';

//TODO: Refactor these types to match table row data types
export type RowValue = string | number | boolean | any;

//TODO: Refactor to implement generic TableRow<TData> for type safety
export interface TableRow {
  id: string | number;
  rows?: TableRow[];
  [key: string]: RowValue;
}

export interface TablePaginationProps {
  totalItems: number;
  pageIndex: number;
  totalPages: number;
  nextDisabled: boolean;
  prevDisabled: boolean;
  onPageChange: (page: number) => void;
  onNextPage: () => void;
  onPrevPage: () => void;
}

export interface TableColumn<R extends TableRow> {
  id: string;
  acessorKey?: string;
  label: ReactNode;
  align?: Alignment;
  alignHeader?: Alignment;
  render?: (value: RowValue, row: R) => ReactNode;
  sortable?: boolean;
  cellSeparator?: boolean;
  columnSeparator?: boolean;
  sortFn?: (a: R, b: R, sortDirection: SortDirection) => number;
  className?: string;
  key?: string;
  colSpan?: number;
}

export type SortDirection = 'ascending' | 'descending';
export enum EnumSortDirection {
  'ascending' = 'ascending',
  'descending' = 'descending',
}

export interface TableSort {
  columnId: string;
  direction: SortDirection;
}

export interface SortProps {
  sorting?: TableSort[];
  onSort?: (columnId: string) => void;
}
export const DEFAULT_PAGE_SIZE = 10;
